// #region imports

// --- Angular
import { Routes, Route } from '@angular/router';
import { Injectable } from '@angular/core';

// -- HS Code
import { ShellComponent } from '../../shared/shell/shell.component';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class ShellService {
  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: ShellComponent,
      children: routes,
      // =canActivate: [AuthenticationGuard],
      // Reuse ShellComponent instance when navigating between child views
      data: { reuse: true }
    };
  }
}
